import { MintStatusModel, PaginatedResponse, PaginationParams } from '@arpeggi/shared'
import axios from '../../lib/axios'

export interface GetMintStatusesParams
  extends Omit<PaginationParams<MintStatusModel>, 'order' | 'orderBy'> {
  walletAddress?: string
  tokenId?: number
  completed?: boolean
}

export const useMintStatusAPI = () => {
  const getMintStatuses = async (params: GetMintStatusesParams) => {
    const { data } = await axios.get<PaginatedResponse<MintStatusModel>>('/api/v2/mint-statuses', {
      params
    })

    return data
  }

  const getOneMintStatus = async (jobId: string) => {
    const { data } = await axios.get<MintStatusModel>(`/api/v2/mint-statuses/${jobId}`)

    return data
  }

  return { getMintStatuses, getOneMintStatus }
}
